
import { AES,enc } from "crypto-js";
const secret_key = '4d3a23fba54bbef1e14dd44ba9591612';
const encryptedAccessToken = localStorage.getItem('access_token');
const decryptedAccessToken = encryptedAccessToken
  ? AES.decrypt(encryptedAccessToken, secret_key).toString(enc.Utf8)
  : null;

export {encryptedAccessToken, decryptedAccessToken };
